// LOAD ALL THE READ ONLY DATA
import { makeSetReducer } from "./utils";

export const tipoIncidenciasFullfilledReducer = makeSetReducer(['tipo_incidencias/fullfilled']);